import React from "react";
import { deleteCourseApi } from "../../../data/api";
import { getStudioHomeCoursesV2 } from "../../../data/api";
import { fetchCourseDataSuccessV2 } from "../../../data/slice";
import { useDispatch } from "react-redux";
import { StrictDict } from "../../../../editors/utils";

export const state = StrictDict({
  confirmed: (val) => React.useState(val), // eslint-disable-line
});

export const nullMethod = () => ({});

const useDeleteCourse = ({ closeModal, courseId }) => {
  const dispatch = useDispatch();
  const [isConfirmed, setIsConfirmed] = React.useState(false);

  const deleteCourse = async () => {
    await deleteCourseApi(courseId);
    const coursesData = await getStudioHomeCoursesV2("", {});
    dispatch(fetchCourseDataSuccessV2(coursesData));
  };

  const handleClose = () => {
    closeModal();
    setIsConfirmed(false);
  };

  const handleConfirm = (e) => {
    setIsConfirmed(true);
    deleteCourse();
    closeModal();
  };

  return {
    handleConfirm,
    handleClose,
  };
};

export default useDeleteCourse;
